import { Icon, TaskForm, getTranslatedText } from '@nile/components';

import {
  Sheet,
  Button,
  Heading,
  RadioButton
} from '@superops/ui-design-system';
import { PlusCircle } from '@styled-icons/fa-solid/PlusCircle';
import { GET_ALL_SOP } from '@nile/banyan/src/Graphql/Mutations/sop';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { restructureGetAllSOPs } from '@nile/banyan/src/Utils/helper';

const SliderWrapper = styled.div`
  padding: 30px;
  height: 100vh;
  overflow: auto;
  width: 30vw;
  background: #fff;
`;

const ButtonWrap = styled.div`
  padding: 8px 0;
`;

function AssociateRunbookSheet(props) {
  const { intl, ticket } = props;
  return (
    <div>
      <Sheet open={props.state} onClose={props.toggleSheetActive}>
        <AssociateRunbook ticket={ticket} {...props} />
      </Sheet>
    </div>
  );
}

function AssociateRunbook(props) {
  const { ticket } = props;
  const [selectedRunbook, setSelectedRunbook] = useState(ticket?.sop);
  const { loading, data, error } = useQuery(GET_ALL_SOP, {
    fetchPolicy: 'network-only'
  });
  if (loading) return <div>loading...</div>;
  const associateRunbook = () => {
    props.associateRunbook(selectedRunbook);
  };
  const stopEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const onChange = (sop) => {
    setSelectedRunbook(sop);
  };

  return (
    <SliderWrapper>
      <div className="flex">
        <Heading element="h1">
          <FormattedMessage id="ticket.details.actions.associateRunbook" />
        </Heading>
        <div className="mlauto">
          <Button id="associateRunBook" primary onClick={associateRunbook}>
            <FormattedMessage id="common.save" />
          </Button>
        </div>
      </div>
      <div className="flex col mt20">
        {restructureGetAllSOPs(data.getAllSOPs).map((item) => {
          return (
            <ButtonWrap>
              <RadioButton
                label={item.name}
                id={item.name}
                name={item.name}
                checked={selectedRunbook?.sopId === item?.sopId}
                onChange={() => onChange(item)}
              />
            </ButtonWrap>
          );
        })}
      </div>
    </SliderWrapper>
  );
}

export default injectIntl(AssociateRunbookSheet);
